import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Css from './SkeletonItem.module.css'


const SkeletonItem = (props) => {
    return (
        <>
            <div className={Css.container}>
                <div style={{ display: 'flex', justifyContent: 'flex-start' }} >
                    <Skeleton variant="rectangular" width="15%" height={20} sx={{ mt: 2 }} />
                    <Skeleton variant="rectangular" width="15%" height={20} sx={{ mt: 2, ml: 2 }} />
                </div>
                <div className={Css.ItemContainer}>
                    <div className={Css.SwiperSlideItem}>
                        <Skeleton variant="rectangular" width="100%" height={320} sx={{ mt: 2 }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Skeleton variant="rectangular" width="25%" height={64} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="25%" height={64} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="25%" height={64} sx={{ mt: 2 }} />
                        </div>
                    </div>
                    <div className={Css.blockRight}>
                        <Skeleton variant="rectangular" width="25%" height={48} sx={{ mt: 6 }} />
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }} >
                            <Skeleton variant="rectangular" width="15%" height={32} sx={{ mt: 2 }} />
                            <Skeleton variant="rectangular" width="15%" height={32} sx={{ mt: 2, ml: 2 }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Skeleton variant="rectangular" width="30%" height={48} sx={{ mt: 6, mr: 2 }} />
                            <Skeleton variant="rectangular" width="45%" height={48} sx={{ mt: 6, mr: 2 }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Skeleton variant="rectangular" width="30%" height={150} sx={{ mt: 6, mr: 2 }} />
                            <Skeleton variant="rectangular" width="45%" height={150} sx={{ mt: 6, mr: 2 }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Skeleton variant="rectangular" width="45%" height={32} sx={{ mt: 6, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 6, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 6, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 6, mr: 2 }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Skeleton variant="rectangular" width="45%" height={32} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 2, mr: 2 }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Skeleton variant="rectangular" width="45%" height={32} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 2, mr: 2 }} />
                            <Skeleton variant="rectangular" width="30%" height={32} sx={{ mt: 2, mr: 2 }} />
                        </div>
                    </div>

                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                    <Skeleton variant="rectangular" width={265} height={265} sx={{ mt: 6, mr: 2 }} />
                    <Skeleton variant="rectangular" width={265} height={265} sx={{ mt: 6, mr: 2 }} />
                    <Skeleton variant="rectangular" width={265} height={265} sx={{ mt: 6, mr: 2 }} />
                    <Skeleton variant="rectangular" width={265} height={265} sx={{ mt: 6, mr: 2 }} />
                </div>

            </div>
        </>
    )
};

export default SkeletonItem;